import { render } from "./ContractDetails.vue?vue&type=template&id=6aedaa12&scoped=true"
import script from "./ContractDetails.vue?vue&type=script&lang=js"
export * from "./ContractDetails.vue?vue&type=script&lang=js"

import "./ContractDetails.vue?vue&type=style&index=0&id=6aedaa12&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/bos-vue/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aedaa12"]])

export default __exports__